import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { SettingFormItem, SettingsUpdateType } from "./types"
import type { HooSettingsResponse, HooSettingsSaveRequest } from "../../../graphql/types"
import { TerminalType } from "../../../graphql/types"
import { SETTINGS_UPDATED } from "../../data/actions"

export const BUSINESS_HOMEPAGE_FORM_SUBMITTED = "setting/businessHomepage/submitted"

export const businessHomepageFormSubmitted = (
    logo: Maybe<string>,
    backgroundImage: Maybe<string>,
    accountImageIdsToDelete: string[]
) => ({
    type: BUSINESS_HOMEPAGE_FORM_SUBMITTED,
    payload: {
        logo: logo,
        backgroundImage: backgroundImage,
        accountImageIdsToDelete: accountImageIdsToDelete,
    },
})

export const BUSINESS_HOMEPAGE_FORM_CLOSED_CLICKED = "setting/businessHomepage/closed/clicked"

export const businessHomepageFormClosedClicked = () => ({
    type: BUSINESS_HOMEPAGE_FORM_CLOSED_CLICKED,
})

export const DISCOUNT_CHANGED = "setting/discount/changed"

export const discountChanged = (turnedOn: boolean, value: Maybe<number>) => ({
    type: DISCOUNT_CHANGED,
    payload: {
        turnedOn: turnedOn,
        value: value,
    },
})

export const FIRST_TIME_DISCOUNT_CHANGED = "setting/firstTimeDiscount/changed"

export const MO_FIRST_ORDER_DISCOUNT_CHANGED = "setting/moFirstOrderDiscount/changed"
export const moFirstOrderDiscountChanged = (
    turnedOn: boolean,
    type: "percentage" | "absolute",
    value: Maybe<number>,
    name: string
) => ({
    type: MO_FIRST_ORDER_DISCOUNT_CHANGED,
    payload: { turnedOn: turnedOn, type: type, value: value, name: name },
})

export const firstTimeDiscountChanged = (turnedOn: boolean, value: Maybe<number>) => ({
    type: FIRST_TIME_DISCOUNT_CHANGED,
    payload: {
        turnedOn: turnedOn,
        value: value,
    },
})

export const SETTING_FORM_SUBMITTED = "setting/form/submitted"
export const settingFormSubmitted = (
    oldValue: Maybe<SettingFormItem>,
    newValue: Record<string, any>,
    locationId?: Maybe<string>
) => ({
    type: SETTING_FORM_SUBMITTED,
    payload: {
        oldValue: oldValue,
        newValue: newValue,
        locationId: locationId,
    },
})

export const ACCOUNT_SETTING_FORM_SUBMITTED = "account-setting/form/submitted"
export const accountSettingFormSubmitted = (oldValue: Maybe<SettingFormItem>, newValue: SettingFormItem) => ({
    type: ACCOUNT_SETTING_FORM_SUBMITTED,
    payload: {
        oldValue: oldValue,
        newValue: newValue,
    },
})

export const TERMINAL_SETTING_FORM_SUBMITTED = "terminal-setting/form/submitted"
export const terminalSettingFormSubmitted = (
    oldValue: Maybe<SettingFormItem>,
    newValue: Record<string, any>,
    terminalType: TerminalType = TerminalType.Register
) => ({
    type: TERMINAL_SETTING_FORM_SUBMITTED,
    payload: {
        oldValue: oldValue,
        newValue: newValue,
        terminalType: terminalType,
    },
})

export const ON_SETTINGS_TERMINAL_PICKER_SUBMITTED = "terminal-setting/picker/submitted"

export const onSettingsTerminalPickerSubmitted = (terminalIds: string[]) => ({
    type: ON_SETTINGS_TERMINAL_PICKER_SUBMITTED,
    payload: {
        terminalIds: terminalIds,
    },
})

export const SETTINGS_SAVE_ENDED = "settings/save/ended"

export const settingsSaveEnded = () => ({
    type: SETTINGS_SAVE_ENDED,
})

export const MIB_TOGGLE_LOCATIONS_MODAL = "mib/open/locationsModal"

export const mibToggleLocationsModal = (opened: boolean, type: string) => ({
    type: MIB_TOGGLE_LOCATIONS_MODAL,
    payload: {
        opened: opened,
        type: type,
    },
})

export const SETTINGS_IMAGE_UPLOAD_MODAL_TOGGLE_CLICKED = "settings/image/modal/toggle/clicked"

export const settingsImageUploadModalToggleClicked = (opened: boolean, file: Maybe<string>) => ({
    type: SETTINGS_IMAGE_UPLOAD_MODAL_TOGGLE_CLICKED,
    payload: {
        opened: opened,
        file: file,
    },
})

export const SETTINGS_IMAGE_UPLOAD_MODAL_CONFIRM_CLICKED = "settings/image/modal/confirm/clicked"

export const settingsImageUploadModalConfirmClicked = (file: any) => ({
    type: SETTINGS_IMAGE_UPLOAD_MODAL_CONFIRM_CLICKED,
    payload: {
        file: file,
    },
})

export const SETTINGS_IMAGE_UPLOAD_RESET_DATA = "settings/image/modal/resetData"

export const settingsImageUploadResetData = () => ({
    type: SETTINGS_IMAGE_UPLOAD_RESET_DATA,
})

export const FETCH_HOO_SETTINGS_SUCCESS = "setting/hoo/data/success"

export const fetchHooSettingsSuccess = (data: HooSettingsResponse) => ({
    type: FETCH_HOO_SETTINGS_SUCCESS,
    payload: {
        data: data,
    },
})

export const REFETCH_ONLINE_ORDERING_SETTINGS = "setting/onlineOrdering/refetch"

export const refetchOnlineOrderingSettings = () => ({
    type: REFETCH_ONLINE_ORDERING_SETTINGS,
})

export const SEPARATE_HOO_FORM_SUBMITTED = "setting/separateHoo/submitted"

export const separateHooFormSubmitted = (data: HooSettingsSaveRequest) => ({
    type: SEPARATE_HOO_FORM_SUBMITTED,
    payload: {
        data: data,
    },
})

export const CASH_PAYMENT_SETTINGS_FORM_SUBMITTED = "setting/payment/cashPayment/submitted"

export const cashPaymentSettingsFormSubmitted = (data: Record<string, any>) => ({
    type: CASH_PAYMENT_SETTINGS_FORM_SUBMITTED,
    payload: {
        data: data,
    },
})

export const UPDATE_SETTING_REQUESTED = "data/setting/update/requested"

export const updateSettingRequested = (
    key: Maybe<string>,
    value: Maybe<any>,
    locationId: Maybe<string>,
    terminalId: Maybe<string>
) => ({
    type: UPDATE_SETTING_REQUESTED,
    payload: {
        key: key,
        value: value,
        locationId: locationId,
        terminalId: terminalId,
    },
})

export const settingsUpdateEventRequested = (settingsToSave: SettingsUpdateType[]) => ({
    type: SETTINGS_UPDATED,
    payload: {
        settings: settingsToSave,
    },
})
